var DisplayLocation = {
  BACKGROUND: 0,
  FOREGROUND: 1
};
var Constants = {
  DisplayLocation: DisplayLocation
};

export { DisplayLocation, Constants as default };
